type Tranche = { percentage: number; days: number };

// Decodes the 2 legacy fixed deposit-preset ids into the generic
// {percentage, days} shape, so picking one of them immediately populates
// paymentSchedule (the backend only ever needs to read that field for any
// customer/user who touches the dropdown from now on — see
// services/billing/echeances.ts on the backend).
export const decodeLegacyDepositPreset = (id: string): Tranche[] | null => {
    const match = id?.match(/^(\d+)pct-deposit-(\d+)pct-30days$/);
    if (!match) return null;
    return [
        { percentage: parseInt(match[1], 10), days: 0 },
        { percentage: parseInt(match[2], 10), days: 30 },
    ];
};

export const DEFAULT_CUSTOM_SCHEDULE: Tranche[] = [
    { percentage: 50, days: 30 },
    { percentage: 50, days: 45 },
];

export const CUSTOM_SCHEDULE_OPTION = {
    _id: 'custom-schedule',
    name: 'Échéancier personnalisé...',
};
